const t = "_wrapper_1s4rv_1", s = "_buttons_1s4rv_8", r = {
  wrapper: t,
  buttons: s
};
export {
  s as buttons,
  r as default,
  t as wrapper
};
//# sourceMappingURL=index.es5830.js.map
